import React, { useEffect, useState } from 'react';

import { Table, InlineEditColumnProps } from '@digital/ui';
import { Historico } from '@app/api/parametro';

interface TabelaProps {
  hist: Historico[];
  paginacao: any;
  relatorioRotinaParamentro: boolean
}

const TableHistorico = (props: TabelaProps) => {
  const { hist, paginacao, relatorioRotinaParamentro } = props;

  const customColumns = () => {
    const collunas = [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Parâmetro',
        dataIndex: 'nomeParametro',
        width: '20%',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: '15%',
      },
      {
        title: 'Data/Hora',
        dataIndex: 'data',
        width: '25%',
      },
    ] as InlineEditColumnProps<Historico>[];

    if (relatorioRotinaParamentro != true) {
      collunas.push({
        title: 'Responsável',
        dataIndex: 'responsavel',
        width: '10%',
      })
    }

    if (relatorioRotinaParamentro) {
      collunas.push({
        title: 'Estimativa da próxima execução',
        dataIndex: 'proximaExecucao',
        width: '10%',
      })
    }

    collunas.push(
      {
        title: 'Observação',
        dataIndex: 'observacao',
        width: '30%',
      }
    )

    return collunas;
  };

  return (
    <>
      <Table
        dataSource={hist}
        columns={customColumns()}
        rowKey="id"
        pagination={paginacao}
      />
    </>
  );
};

export default TableHistorico;
